import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'
import { Checkbox, FormHelperText } from '@material-ui/core'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../services/FirebaseService'
import FlexView from 'react-flexview/lib'
import { liabilityLimitPretty } from '../../services/utils'

export const IsCommercialPopup = () => {
  const [open, setOpen] = React.useState(false)
  const [checked, setChecked] = React.useState(false)
  const [error, setError] = React.useState(false)
  const [liabilityLimit, setLiabilityLimit] = React.useState(0)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleDisagree = () => {
    setOpen(false)
  }

  const handleAgree = () => {
    if (!checked) {
      setError(true)
      return
    }
    setOpen(false)
    EventEmitterService.dispatch(EventKey.USER_ACCEPT_COMMERCIAL)
  }

  const handleChange = (event) => {
    setChecked(event.target.checked)
  }

  React.useEffect(() => {
    let id = EventEmitterService.subscribe(
      EventKey.SHOW_COMMERCIAL_POPUP,
      (liabilityLimit) => {
        setLiabilityLimit(liabilityLimit)
        handleClickOpen()
      }
    )

    return function cleanup() {
      EventEmitterService.unsubscribe(EventKey.SHOW_COMMERCIAL_POPUP, id)
    }
  }, [])

  return (
    <Dialog
      open={open}
      onClose={handleDisagree}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">
        {liabilityLimitPretty(liabilityLimit)} Liability Insurance is available
        for certified pilots
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          You must read and accept the terms below to proceed
        </DialogContentText>
        <DialogContentText id="alert-dialog-description">
          <FlexView>
            <Checkbox
              checked={checked}
              onChange={handleChange}
              color="primary"
            />
            {
              FirebaseService.getObject(
                FirebaseConfigKey.COMMERCIAL_VIEW_STRINGS_JSON
              )['terms_and_agreements_suffix']
            }
            .
          </FlexView>
        </DialogContentText>
        {error && !checked && (
          <FormHelperText error>
            To agree you must check the checkbox
          </FormHelperText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDisagree} color="primary">
          Cancel
        </Button>
        <Button onClick={handleAgree} color="primary" autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  )
}
